import store from '@/store/index.js'
let dic = store.state.dic;

import { validateMoney, validatePhone } from "@/libs/elementChecker.js";

const validateUnit = (rule, value, callback) => {
    console.log(value)
    if (value) {
        if (value.length <= 15) {
            callback()
        } else {
            callback(new Error('单位名称不超过15字'));
        }
    } else {
        callback(new Error('请输入单位'));
    }
}
const validateJob = (rule, value, callback) => {
    if (value) {
        if (value.length <= 5) {
            callback()
        } else {
            callback(new Error('职务名称不超过5字'));
        }
    } else {
        callback(new Error('请输入职务'));
    }
}

const validateAge = (rule, value, callback) => {
    if (value) {
        if (value.length <= 5) {
            callback()
        } else {
            callback(new Error('不超过5字'));
        }
    } else {
        callback(new Error('请输入'));
    }
}

export default function Configs(that) {

    const formItems = [

        {
            label: "姓名",
            span: 3,
            model: "name",
        },
        {
            label: "关系",
            span: 3,
            model: "relationship",
        },
        {
            span: 3,
            label: "单位",
            model: "unit",
            type: 'date',
        },
        {
            label: "出生日期",
            span: 3,
            model: "dateBirth",
        },
        {
            label: "政治面貌",
            span: 3,
            model: "politicalCode",
        },
        {
            label: "联系电话",
            span: 3,
            model: "contactPhone",
        },
        {
            label: "民族",
            span: 3,
            model: "nationCode",
        },
        {
            label: "职务",
            span: 2,
            model: "job",
        },
    ]




    const formRules = {
        relationship: [{
            required: true,
            message: "请输入关系",
            trigger: "blur"
        }],

        name: [{
            required: true,
            message: "请输入姓名",
            trigger: "blur"
        }],
        age: [
            { required: true, message: '年龄不能为空' },
            { type: 'number', message: '年龄必须为数字值' }
        ],
        dateBirth: [{
            required: true,
            message: "请选择出生日期",
            trigger: "change"
        }],
        contactPhone: [{
            trigger: "blur",
            // message: "请输入",
            required: true,
            validator: validatePhone,
        }],
        politicalCode: [{
            required: true,
            message: "请选择政治面貌",
            trigger: "change"
        }],
        nationCode: [{
            required: true,
            message: "请选择民族",
            trigger: "change"
        }],
        unit: [{
            required: true,
            // message: "请输入",
            trigger: "blur",
            validator: validateUnit,
        }],
        job: [{
            required: true,
            // message: "请输入",
            trigger: "blur",
            validator: validateJob,
        }],
        income: [{
            trigger: "blur",
            // message: "请输入",
            required: true,
            validator: validateMoney,
        }],

    }

    return {
        formItems,
        formRules,
    }
}
